import { render, staticRenderFns } from "./selected-item-pills.vue?vue&type=template&id=6565301e&"
import script from "./selected-item-pills.vue?vue&type=script&lang=js&"
export * from "./selected-item-pills.vue?vue&type=script&lang=js&"
import style0 from "./selected-item-pills.vue?vue&type=style&index=0&id=6565301e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports